module.exports = "/_next/static/images/epn_2-acaa91db11219e41043216b9840dbad1.jpeg";